<template>
    <button style="display:none;" type="button" class="btn btn-primary" data-bs-toggle="modal"
    data-bs-target="#mdlQI" id="btnOpenQI">Open</button>
  <div class="modal fade" id="mdlQI" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{assmnt.name}}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              <editQuote v-if="assmnt.id != 0" :idQuote="assmnt.id" behavior="admin" @accepted="accept" />
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" id="btnCloseQI" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import editQuote from "../../components/global/quote-cmp.vue";
import { ref, defineExpose } from "vue";

let assmnt = ref({id:0,name:''})

const open = (id,name) => {
    assmnt.value.id=id
    assmnt.value.name=name
    document.getElementById("btnOpenQI").click();
}


defineExpose({
  open
});
</script>